import { GET_ORDER_PAYMENT_INFO } from '../actionTypes/OrderActionTypes';
import { HANDLE_ORDER_PAYMENT_INFO } from '../actionTypes/PaymentActionTypes';

export const getOrderPaymentInfo = (payload) => ({
    type: GET_ORDER_PAYMENT_INFO,
    payload,
});

export const getCreditCardInfo = (payload) => ({
    type: HANDLE_ORDER_PAYMENT_INFO,
    payload,
});
export default getOrderPaymentInfo;
